import { gql, useQuery } from '@apollo/client'
import { Table, Progress, Button, Alert } from 'reactstrap'
import DatetimeRenderer from '../../Material/DatetimeRenderer'
import './RenderArgyleGigs.css'


const AllArgyleGigsQuery = gql`query AllArgyleGigs($driverId: ID!, $activeOnDatetime: DateTime, $activeOnDate: Date, $limit: Int, $startDatetimeCursor: DateTime){
    allArgyleGigs(driverId: $driverId, activeOnDatetime: $activeOnDatetime, activeOnDate: $activeOnDate, limit: $limit, startDatetimeCursor: $startDatetimeCursor){
        employer
        gigId
        startDatetime
        endDatetime
        timezone
        startLocationFormattedAddress
        endLocationFormattedAddress
        incomeTotal
        incomeCurrency
        status
        type
        distance
        distanceUnit
        accountId
    } 
}`

export default function RenderArgyleGigs({ driverId, incidentDate, incidentTime, showAll }) {

    const { data: allArgyleGigsData, loading: allArgyleGigsLoading, error: allArgyleGigsError, fetchMore: fetchMoreArgyleGigs } = useQuery(AllArgyleGigsQuery, {
        variables: {
            driverId: driverId,
            activeOnDatetime: incidentDate && incidentTime ? `${incidentDate}T${incidentTime}` : null,
            activeOnDate: incidentDate ? incidentDate : null,
            limit: showAll ? 10 : 5,
        },
        skip: !driverId || !incidentDate,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    })

    const loadMoreArgyleGigs = () => {
        fetchMoreArgyleGigs({
            variables: {
                startDatetimeCursor: allArgyleGigsData?.allArgyleGigs[allArgyleGigsData?.allArgyleGigs.length - 1].startDatetime,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                return {
                    allArgyleGigs: [...previousResult.allArgyleGigs, ...fetchMoreResult.allArgyleGigs],
                }
            },
        })
    }

    return (
        <div className="argyle-gigs-feed">
            {allArgyleGigsError && <Alert color="danger">{allArgyleGigsError.message}</Alert>}
            <div className="argyle-gigs-table-container">
                <Table size="sm" responsive className="argyle-gigs-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Employer</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            {showAll && <th>Start Location</th>}
                            {showAll && <th>End Location</th>}
                            <th>Distance</th>
                            <th>Income</th>
                            {showAll && <th>Type</th>}
                            <th>Status</th>
                        </tr>
                        {allArgyleGigsData?.allArgyleGigs?.map((gig, i) => (
                            <tr>
                                <td>{i + 1}</td>
                                <td className="text-capitalize">{gig.employer}</td>
                                <td><DatetimeRenderer datetime={gig.startDatetime} /></td>
                                <td><DatetimeRenderer datetime={gig.endDatetime} /></td>
                                {showAll && <td>{gig.startLocationFormattedAddress}</td>}
                                {showAll && <td>{gig.endLocationFormattedAddress}</td>}
                                <td>{gig.distance || "???"} {gig.distanceUnit}</td>
                                <td>{gig.incomeCurrency} {gig.incomeTotal || "???"}</td>
                                {showAll && <td className="text-capitalize">{gig.type}</td>}
                                <td className="text-capitalize">{gig.status}</td>
                            </tr>
                        ))}
                        <tr className="argyle-gigs-table__footer">
                            <td colSpan={10} className="text-right">
                                {allArgyleGigsLoading ? <Progress animated value={100} /> : (
                                    !allArgyleGigsData || allArgyleGigsData?.allArgyleGigs?.length === 0 ? <p className="argyle-gigs-empty">No Argyle Gigs Found!</p> : <Button className='primary' size="sm" onClick={loadMoreArgyleGigs} style={{ cursor: "pointer" }}>Load More</Button>
                                )}
                            </td>
                        </tr>
                    </thead>
                </Table>
            </div>
        </div>
    )
}
